import { LegalLayout } from "@/components/site/LegalLayout";

export default function PrivacyPage() {
  return (
    <LegalLayout
      title="Privacy Policy"
      lastUpdated="August 3, 2026"
      path="/privacy-policy"
      metaTitle="Privacy Policy"
      metaDescription="How Danny Clans Media Limited collects, uses, and safeguards personal information across DC Dashboard, including cookies, GDPR-style rights, and data-security practices."
    >
      <p>
        Danny Clans Media Limited ("Company", "we", "our", or "us") respects your
        privacy and is committed to protecting personal information collected through
        the DC Dashboard platform accessible at{" "}
        <a href="https://dannyclans.solutions">dannyclans.solutions</a> and{" "}
        <a href="https://dannyclans.com">dannyclans.com</a> ("Platform").
      </p>

      <h2>1. Information We Collect</h2>
      <h3>Account Information</h3>
      <ul>
        <li>Name</li>
        <li>Company name</li>
        <li>Email address</li>
        <li>Phone number</li>
        <li>Billing information</li>
        <li>Tax information</li>
      </ul>

      <h3>Financial Information</h3>
      <ul>
        <li>Payment method details</li>
        <li>Bank account details</li>
        <li>Transaction history</li>
        <li>Wallet funding records</li>
        <li>Withdrawal records</li>
      </ul>

      <h3>Platform Usage Information</h3>
      <ul>
        <li>Login records</li>
        <li>Device information</li>
        <li>Browser information</li>
        <li>IP addresses</li>
        <li>Activity logs</li>
      </ul>

      <h3>Advertising Information</h3>
      <ul>
        <li>Campaign data</li>
        <li>Advertising account usage</li>
        <li>Advertising spend information</li>
      </ul>

      <h2>2. How We Use Information</h2>
      <p>We use information to:</p>
      <ul>
        <li>Provide Platform services</li>
        <li>Verify user identity</li>
        <li>Process payments</li>
        <li>Prevent fraud</li>
        <li>Comply with legal obligations</li>
        <li>Improve services</li>
        <li>Communicate with users</li>
        <li>Resolve disputes</li>
      </ul>

      <h2>3. Sharing of Information</h2>
      <p>We may share information with:</p>
      <ul>
        <li>Payment processors</li>
        <li>Banking partners</li>
        <li>Advertising platforms</li>
        <li>Professional advisors</li>
        <li>Government authorities when legally required</li>
      </ul>
      <p>We do not sell personal information.</p>

      <h2>4. Data Security</h2>
      <p>We implement commercially reasonable security measures to protect information.</p>
      <p>However, no electronic transmission or storage system can be guaranteed to be completely secure.</p>

      <h2>5. Data Retention</h2>
      <p>Information may be retained:</p>
      <ul>
        <li>For as long as required to provide services</li>
        <li>To comply with legal obligations</li>
        <li>To resolve disputes</li>
        <li>To enforce agreements</li>
      </ul>

      <h2>6. User Rights</h2>
      <p>Subject to applicable law, users may request:</p>
      <ul>
        <li>Access to personal information</li>
        <li>Correction of inaccurate information</li>
        <li>Deletion of personal information</li>
        <li>Withdrawal of consent where applicable</li>
      </ul>

      <h2>7. International Transfers</h2>
      <p>Information may be processed and stored in multiple jurisdictions.</p>
      <p>By using the Platform, users consent to such transfers.</p>

      <h2>8. Cookies &amp; Tracking Technologies</h2>
      <p>
        The Platform uses cookies and similar technologies to support essential site
        functionality, remember user preferences, measure aggregate usage, and
        (subject to consent) deliver relevant marketing communications. You may
        manage your preferences at any time via the "Cookie preferences" link in the
        site footer. Where required by applicable law, marketing cookies (including
        Meta Pixel and Google Analytics) are loaded only after affirmative consent is
        given, in line with our implementation of Google Consent Mode v2.
      </p>

      <h2>9. Changes</h2>
      <p>
        We may update this Privacy Policy at any time. For material changes, we will
        provide notice via the email address associated with your account. Continued
        use of the Platform after the effective date constitutes acceptance of the
        revised Policy.
      </p>

      <h2>10. Contact</h2>
      <p>
        Danny Clans Media Limited<br />
        Email: <a href="mailto:help@dannyclans.com">help@dannyclans.com</a><br />
        Address: S022, 2/F, The Capital, 61–65 Chatham Road South, Tsim Sha Tsui, Hong Kong
      </p>
    </LegalLayout>
  );
}
